import { API_BASE_URL } from '../../configs/Constants'



export async function getQueueData() {
  try {
    let url = API_BASE_URL + '/data/queue/status'
    const response = await fetch(url, {
      method: 'GET',
    })
    if (!response.ok) {
      throw new Error(`This is an HTTP error: The status is ${response.status}`)
    }
    return await response.text()
  } catch (err) {
    console.log(err)
  }
}



export async function getServerStatus(name) {
  try {
    let url = API_BASE_URL + `/${name}/health`
    const response = await fetch(url, {
      method: 'GET',
    })
    if (!response.ok) {
      throw new Error(`This is an HTTP error: The status is ${response.status}`)
    } else {
      return true
    }
  } catch (err) {
    return false
  }
}

export async function getUserTasksData(userId) { //this route returns table data using userid
  try {
    let url = API_BASE_URL + `/data/tasks/${userId}`
    console.log("Task details URL:"+url)
    const response = await fetch(url, {
      method: 'GET',
    })
    if (!response.ok) {
      throw new Error(`This is an HTTP error: The status is ${response.status}`)
    }
    let actualData = await response.text()
    return actualData
  } catch (err) {
    console.log(err)
    return false
  }
}

export async function getTaskDetailsData(smiles) {
  try {
    let url = API_BASE_URL + `/data/results`
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify({
        smiles: smiles,
      }),
    })
    if (!resp.ok) {
      throw new Error(`This is an HTTP error: The status is ${resp.status}`)
    }
    let actualData = await resp.json()
    return actualData
  } catch (err) {
    console.error(err)
    return false
  }
}
